import type { SaveSlotInput } from "./PersistenceManager.js";

/**
 * Module-singleton carrier for the "live engine → SaveSlotInput" function.
 *
 * `main.tsx` owns the live refs (input handler, current map, narrative
 * manager) so it's the natural place to build a save input. The React UI
 * (`MainMenu` → `SaveLoadScreen`) only needs to *call* such a function, so
 * we hand it across the boundary through this tiny module rather than
 * threading it through props from the app root.
 *
 * Returns `null` until `main.tsx` has initialized the first map. The
 * `MainMenu` gates the "Save / Load" button on the provider being set.
 */

type Provider = () => SaveSlotInput;

let provider: Provider | null = null;

export function setSaveInputProvider(p: Provider | null): void {
  provider = p;
}

export function getSaveInputProvider(): Provider | null {
  return provider;
}
